import { deleteAllCVDrafts } from '../services/documentService';
import { clearAllCVDraftsFromLocalStorage } from './clearCVDrafts';

// Comprehensive cleanup function for CV drafts
export const comprehensiveCVDraftCleanup = async () => {
  console.log('🧹 Starting comprehensive CV draft cleanup...');
  
  try {
    // 1. Clear all CV drafts from Firebase
    const deletedCount = await deleteAllCVDrafts();
    console.log(`✅ Deleted ${deletedCount} CV drafts from Firebase`);
    
    // 2. Clear all CV drafts from localStorage
    clearAllCVDraftsFromLocalStorage();
    
    // 3. Clear any session storage items
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key && (key.includes('cv') || key.includes('draft') || key.includes('autosave'))) {
        sessionStorage.removeItem(key);
      }
    }
    
    // 4. Dispatch event to update UI
    window.dispatchEvent(new CustomEvent('cvDraftsUpdated'));
    
    // 5. Force reload documents
    window.location.reload();
    
    return { success: true, deletedCount };
  } catch (error) {
    console.error('❌ Comprehensive cleanup failed:', error);
    return { success: false, error };
  }
};

// Function to run in browser console for emergency cleanup
(window as any).emergencyCVDraftCleanup = comprehensiveCVDraftCleanup;